import React from 'react'
import { NavLink } from 'react-router-dom'

export const Step4Creado = () => {
    return (
        <div className="row">
            <div className="col-12">
                <div className="text-center">
                    <h2 className="mt-0">
                        <i className="fa fa-check fa-3x"></i>
                    </h2>
                    <h3 className="mt-0">Felicidades!</h3>
                    <p className="w-75 mb-2 mx-auto">Ahora formas parte de SkyFest.</p>
                    <NavLink to="/login" className="btn btn-primary btn-block">
                        <i className="fa fa-arrow-left"></i> Regresar a Login
                    </NavLink>
                </div>
            </div>
        </div>
    )
}
